import api from '../utils/api';
import config from '../config';

const caseService = {
  // ── Single upload ──
  upload: (formData) =>
    api.post('/cases/upload/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then(r => r.data),

  // ── List / detail ──
  getAll: () =>
    api.get('/cases/').then(r => r.data.results || r.data),

  getById: (caseId) =>
    api.get(`/cases/${caseId}/`).then(r => r.data),

  // ── Batch ──
  batchAdd: (formData) =>
    api.post('/cases/batch/add/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then(r => r.data),

  batchStatus: (batchId) =>
    api.get(`/cases/batch/${batchId}/`).then(r => r.data),

  batchGenerate: (batchId) =>
    api.post(`/cases/batch/${batchId}/generate/`).then(r => r.data),

  batchRemoveItem: (batchId, itemId) =>
    api.delete(`/cases/batch/${batchId}/?item_id=${itemId}`).then(r => r.data),

  // ── Image URL helper ──
  getImageUrl: (s3Key) => {
    if (!s3Key) return null;
    if (s3Key.startsWith('http')) return s3Key;
    // Avoid /media/media/ duplication
    const base = (config.MEDIA_URL || '').replace(/\/+$/, '');
    const key = s3Key.replace(/^\/+/, '');
    if (base.endsWith('/media')) {
      return `${base}/${key}`;
    }
    return `${base}/media/${key}`;
  },

  // ── Fetch image with auth headers as blob ──
  getImageBlob: (s3Key) => {
    const url = caseService.getImageUrl(s3Key);
    if (!url) return Promise.reject('No URL for key');
    return api.get(url, { responseType: 'blob' }).then(r => r.data);
  },
};

export default caseService;